module.exports = __webpack_public_path__ + "static/media/cmcc-v1-wifi.9fd05f13.png";